import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/price',
  title: window.language['menu.statistics.price'],
  component: dynamicWrapper(app, [import('../../HomePage/model'),import('../Org/model'), import('../Role/model'), import('../SysConfig/model'), import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/System/Price/index.js